import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import imageCopy from '../../assets/images/logo-2.png'
import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { GetToken, RemovRoles, homeForRole } from '../../utils/helper/helper';
import { revokeSession } from '../../utils/config/apiClient';
import { clearCheckoutIntent } from '../../utils/helper/checkout';
import { GhostButton, ResponsiveNavbar } from 'react-hamburger-menus';
import "react-hamburger-menus/dist/style.css";
import { SignUpChoiceModal } from './SignUpChoiceModal';

function Headertwo() {
  const [tokenItem, setTokenItem] = useState()
  const [smShow, setSmShow] = useState(false);
  const [item, setItem] = useState(window.location.pathname);
  const navigate = useNavigate();
  const handleClose = () => setSmShow(false);
  const handleShow = () => setSmShow(true);
  // #111: removed. Every render wrote "details" - "undefined undefined" until the profile below
  // arrived - and nothing reads that key; TopNavbar only removes it. The profile fetch existed
  // only to fill it, so it went too: two API calls on every public page for nothing.
  // const isUserData = JSON.parse(localStorage.getItem('isUser'));
  // const userId = isUserData?.userId;
  // localStorage.setItem("details", userData?.firstName + " " + userData?.lastName)
  // const dataList = localStorage.getItem("details")


  // #111: signed in means a token AND a role - the role being what handleLandingPage picks the
  // dashboard by. The token alone was enough here before, so a token with no role (a failed
  // login used to leave one) showed Dashboard, and that click ended on the Login page.
  useEffect(() => {
    setTokenItem(localStorage.getItem('role') ? GetToken() : null)
  }, []);




  // FE-05: revokeSession() ends the session on the server and removes the token pair; loading the
  // sign-in page takes the SignalR connection down with this one.
  // #222: a sign-out lands on the sign-in page. This went to "/" (Home) and reloaded it.
  async function logout() {
    await revokeSession();
    RemovRoles()
    localStorage.removeItem('Role');
    clearCheckoutIntent();

    localStorage.removeItem("isUser");
    localStorage.removeItem("instruction");
    // localStorage.clear();
    window.location.assign('/Login');
  }

  const handleActiveStatus = () => {
    setItem(window.location.pathname);

  };

  const roles = localStorage.getItem("role")

  const isUser = JSON.parse(localStorage.getItem('isUser'));


  // FE-01 (#103): the old if/else sent every role that was not Manager or Player to /WebAdmin -
  // Admin included, whose dashboard is /SuperAdmin, so an Admin's click was bounced to Login.
  const handleLandingPage = () => {
    navigate(homeForRole(roles) ?? '/Login');
  }

  // FE-02: the ReceiveUserStatus subscription and its "Session Time Out" modal are gone. The modal
  // only rendered for `dataItem === true`, but the payload is an email, so it never showed - while
  // every sign-in's email still arrived here. TopNavbar handles the sign-in-elsewhere notice.

  return (
    <>
      <div className='container-fluid'>

        <nav className='header navbar navbar-expand-lg navbar-light'>
          <ResponsiveNavbar className="header"
            logo={<><Link to="/Home"><img src="../image/logo1.png" className='landing-header-logo' /></Link></>}

          >
            <ul>
              <li> <Link to="/Home" className={`nav-link ${item == "/" || item == "/Home" ? " active" : ""}`} onClick={() => handleActiveStatus()}>Home</Link></li>
              <li> <Link to="/AboutUs" className={`nav-link ${item == "/AboutUs" ? " active" : ""}`} onClick={() => handleActiveStatus()}>About Us</Link></li>
              <li> <Link to="/Works" className={`nav-link ${item == "/Works" ? " active" : ""}`} onClick={() => handleActiveStatus()}>How it Works</Link></li>
              <li> <Link to="/ManagerTips" className={`nav-link ${item == "/ManagerTips" ? " active" : ""}`} onClick={() => handleActiveStatus()}>Manager Tips</Link></li>
              <li><Link to="/Faq" className={`nav-link ${item == "/Faq" ? " active" : ""}`} onClick={() => handleActiveStatus()}>FAQ</Link></li>
              <li> <Link to="/ContactUs" className={`nav-link ${item == "/ContactUs" ? " active" : ""}`} onClick={() => handleActiveStatus()}>Contact Us</Link></li>
              {
                tokenItem == null ? <>
                  {/* #276: one element, so one Tab stop; a button inside a link took two. */}
                  <li><Button as={Link} to="/login" variant="outline-success">Login</Button></li>
                  <li><Button variant="primary" onClick={handleShow}>Sign Up</Button></li>
                </> : <>
                  <Button variant='primary' onClick={handleLandingPage} style={{ fontSize: "15px", padding: "5px 5px", marginRight: "15px" }}>Dashboard</Button>
                  <li>
                    <Dropdown>

                      <Dropdown.Toggle variant="none" className='d-flex align-items-center p-0 '>

                        <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip1">

                          {isUser?.fullName}
                        </Tooltip>}>
                          <div className='text-hide user-list-item'>
                            {isUser?.fullName}
                          </div>
                        </OverlayTrigger>
                      </Dropdown.Toggle>
                      {/* #111: always offered while signed in. It used to depend on the stored
                          name, so a session with no "isUser" left no way to sign out. */}
                      <Dropdown.Menu className="logout-topbar">
                        <Dropdown.Item onClick={logout} >
                          Logout
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </li>
                </>
              }

            </ul>



          </ResponsiveNavbar>
        </nav>
      </div>
      <SignUpChoiceModal show={smShow} onHide={handleClose} />
    </>
  );
}

export default Headertwo;